import React from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { CommonColors } from "fe-web-components/colors/commonColors";

//region [[ Styles ]]
const CloseIconButtonView = styled(IconButton)(() => ({
  "&.close-button": {
    position: "absolute",
    top: "1px",
    left: "1px",
    background: "transparent",
    boxShadow: "none",
    zIndex: 1,
    color: CommonColors.Default,
    "&, &:hover, &:active, &:focus": {
      padding: "12px",
    },
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]
interface CloseIconButtonProps {
  onClick: () => void;
  className?: string;
}
//endregion [[ Props ]]

const CloseIconButton = ({
  onClick,
  className,
  ...props
}: CloseIconButtonProps) => {
  return (
    <CloseIconButtonView
      aria-label="close"
      onClick={onClick}
      className={(className || "") + " close-button"}
    >
      <CloseIcon />
    </CloseIconButtonView>
  );
};

export default CloseIconButton;
